/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

/**
 * Sidebar filter constants used for
 * manage codes filtering.
 */
import { IFilterField } from "Interfaces/IFilterField";

import { fieldTypes } from "./FilterFields";

export const defaultListingPageSize = 16;

const BENEFIT_NAME = "benefitName";

export const manageCodesFilterFields: IFilterField[] = [
  {
    key: BENEFIT_NAME,
    text: "Benefit Name",
    type: fieldTypes.SELECT,
  },
];

/**
 * Default values for Registration & Program Status for Student Ambassador
 */
export const CODE_UPLOADS_TEMPLATE =
  "BenefitName,Code,SKU (Only for AwardKits),Expiration Date (mm/dd/yyyy),Assigned to (User ID)";
export const ALLOWED_FILE_SIZE_MB = 0.1; // 100 KB in MB
export const VALID_FILE_TYPES = ["csv"];
export const INVALID_FILE = "Invalid File";
export const INVALID_FILE_SIZE = "Invalid File Size";

/**
 * Default filter values for the azure benefit requests.
 */
export const defaultFilterValues: {
  fieldName: string;
  value: string;
}[] = [];
